export const CLOSE_BROTHERS_MAX_FINANCE_AMOUNT = 200_000;
export const CLOSE_BROTHERS_MIN_AGE = 18;
export const CLOSE_BROTHERS_MAX_AGE = 70;
